import raftRestClient from "../../lib/raft_rest_client";
import { useDrupalSettings } from "../../composables/useDrupalSettings";

const { config } = useDrupalSettings();

const state = {
  documentPermissionList: ["view document content", "create document content"],
  userDocumentPermissions: [],
  documentTypes: [],
  selectedDocumentTypes: [],
  documentListingFilterUpdate: "",
  documentTextFilter: "",
  hasConfirmationsFilter: false,
};

const mutations = {
  setUserDocumentPermissions: (state, perms) =>
    (state.userDocumentPermissions = perms),
  setDocumentTypes: (state, value) => (state.documentTypes = value),
  setSelectedDocumentTypes: (state, value) =>
    (state.selectedDocumentTypes = value),
  setDocumentListingFilterUpdate: (state, value) =>
    (state.documentListingFilterUpdate = value),
  setDocumentTextFilter: (state, value) => (state.documentTextFilter = value),
  setHasConfirmationsFilter: (state, value) =>
    (state.hasConfirmationsFilter = value),
};
const getters = {
  getUserDocumentPermissions: (state) => state.userDocumentPermissions,
  getDocumentTypes: (state) => state.documentTypes,
  getSelectedDocumentTypes: (state) => state.selectedDocumentTypes,
  getDocumentListingFilterUpdate: (state) => state.documentListingFilterUpdate,
  getDocumentTextFilter: (state) => state.documentTextFilter,
  getHasConfirmationsFilter: (state) => state.hasConfirmationsFilter,
};

const actions = {
  fetchRaftDocumentsUserPermissions({ state, commit, rootState }) {
    const query = {
      permissions: state.documentPermissionList,
    };

    // Set group context.  Note: groups are always nodes in B4.
    if (config.groupContext) {
      query["rog-id"] = config.groupContext;
      query["rog-type"] = "node";
    }

    raftRestClient.getRest(
      rootState.config.restUrl + "/perms",
      query,
      (data) => {
        const userPerms = [];
        for (const [key, value] of Object.entries(data.permissions)) {
          if (value) {
            userPerms.push(key);
          }
        }
        commit("setUserDocumentPermissions", userPerms);
      },
      null,
      this,
      true,
    );
  },
  fetchDocumentTypes({ state, commit, rootState }) {
    raftRestClient.getRest(
      "/config_terms",
      {
        vocab: "file_type",
      },
      (data) => {
        const options = [];
        if (data?.config_terms?.length !== 0) {
          data?.config_terms?.forEach((type) => {
            options.push({ uuid: type.uuid, text: type.label, value: type.id });
          });
        }
        commit("setDocumentTypes", options);
      },
      null,
      this,
      true,
    );
  },
  updateSelectedDocumentTypes({ commit }, value) {
    commit("setSelectedDocumentTypes", value);
    commit("setDocumentListingFilterUpdate", new Date().getTime());
  },
  updateDocumentTextFilter({ commit }, value) {
    commit("setDocumentTextFilter", value);
    if (value.length >= 3 || value.length < 1) {
      commit("setDocumentListingFilterUpdate", new Date().getTime());
    }
  },
  updateHasConfirmationsFilter({ commit }, value) {
    commit("setHasConfirmationsFilter", value);
    commit("setDocumentListingFilterUpdate", new Date().getTime());
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
